import { useContext } from 'react';
import { AppProviderContext } from '../providers/AppProvider';

export const useUser = () => {
  const { user, setUser } = useContext(AppProviderContext);
  return { user, setUser };
};
